export interface BookingLayoutAccess {
  bookingId: number;
  customerAccessToken: string;
}

// Never put a booking capability into BrowserRouter state: history.state survives reloads.
let pendingAccess: BookingLayoutAccess | undefined;

export function setBookingLayoutAccess(access: BookingLayoutAccess): void {
  pendingAccess = { ...access };
}

export function peekBookingLayoutAccess(): BookingLayoutAccess | undefined {
  return pendingAccess ? { ...pendingAccess } : undefined;
}

export function clearBookingLayoutAccess(): void {
  pendingAccess = undefined;
}
